import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TableCell } from 'material-ui/Table';
import TableRow from 'spark-ui/Grid/tableBody/TableRow';
import { getRecipientGapPacketById } from 'spark-state/gapPacket/gapPacketReducer';
import Tooltip from 'material-ui/Tooltip';
import TruncatedText from 'spark-ui/ui-kitchen/ingredients/spices/text/TruncatedText';
import styled from 'styled-components';
import { downloadGapPacketSetsForRecipient } from 'spark-api/utilityService';
import Button from 'spark-ui/ui-kitchen/ingredients/spices/Button';
import { refreshGrid } from 'spark-grid';
import { openTempRoute } from 'spark-state/common/app/reducer';

const DownloadLink = styled.a`
	color: #0768FD;
	text-decoration: underline;
	
	&:hover {
        text-decoration: none;
		cursor: pointer;
    } 
`
const RecipientGridRow = ({ rowId }) => {
	const gapPacket = useSelector((state) => getRecipientGapPacketById(state, rowId));
	const enterpriseId = useSelector((state) => state.user.enterpriseId);
	const dispatch = useDispatch();

	const downloadSL = async (entId, gpTitle, safetyIds, setNumber) => {
		await dispatch(downloadGapPacketSetsForRecipient(entId, safetyIds, setNumber, gpTitle));
		dispatch(refreshGrid('GapPacketRecipientResultsGrid'));
	};

	if (!gapPacket) {
		return null;
	}

	return (
		<TableRow hover tabIndex={-1}>
			<TableCell>
				<Tooltip title={gapPacket.gapPacketName} position="bottom-start">
                    <TruncatedText>{gapPacket.gapPacketName}</TruncatedText>
                </Tooltip>
			</TableCell>
			
			<TableCell>{gapPacket.status}</TableCell>
			<TableCell>{gapPacket.orgName}</TableCell>
			<TableCell>{gapPacket.molecule}</TableCell> 
			<TableCell>{gapPacket.protocolNum}</TableCell>
			<TableCell>{gapPacket.distributedDt}</TableCell>
			<TableCell>
				<DisplayDownloadLinks 
					arrayOfSLIDs={gapPacket.gapPackets ? gapPacket.gapPackets : [] } 
					gapPacket={gapPacket} 
					enterpriseId={enterpriseId}
					downloadSL={downloadSL} 
				/>
			</TableCell>
            <TableCell>{gapPacket && (gapPacket.enblAckBtn && gapPacket.enblAckBtn === 'Y') && <AcknowledgeButton disabled={gapPacket.downloadPending} gapPacketId={gapPacket.gapPaketId} />}</TableCell>
		</TableRow>
	);
};

export default RecipientGridRow;
//Patch-7.0.3: Added acknowledge popup to fix multiple acknowledgement event
const AcknowledgeButton = ({ gapPacketId, disabled }) => {
	const dispatch = useDispatch();
	const onClick = (id) => dispatch(openTempRoute('AcknowledgeGapPacket', { gapPacketId: id }));
	return disabled ? (
		<Tooltip
			title="Download Gap Packet for Acknowledging"
			placement="top"
		>
			<Button disabled={disabled} onClick={() => onClick(gapPacketId)}>
				Acknowledge
			</Button>
		</Tooltip>
	) : (
		<Button disabled={disabled} onClick={() => onClick(gapPacketId)}>
			Acknowledge
		</Button>
	);
};
const DisplayDownloadLinks = ( {arrayOfSLIDs, enterpriseId, gapPacket, downloadSL} ) => {
	return ( 
		
		arrayOfSLIDs && arrayOfSLIDs.map( (set, index) => {
			const setNumber = index+1;
			const linkText = `Set ${index+1}`;
			const safetyIds = set;
			const gpTitle = gapPacket && gapPacket.gapPacketName;
			return (
					<React.Fragment>
						<DownloadLink onClick={()=>downloadSL(enterpriseId, gpTitle, safetyIds, setNumber)}>{linkText}<br/></DownloadLink>
					</React.Fragment>
				)
		})
	)
}
